<template>
  <span class="tw-text-neutral tw-font-bold tw-text-base">
    <slot />
  </span>
</template>
